module.exports = __webpack_public_path__ + "static/media/pass.5ffec825.svg";